'use client';

import { useEffect, useState } from 'react';
import { useSearchParams, useRouter } from 'next/navigation';
import ThankYouContent from 'components/gruenland/organisms/thank-you/ThankYouContent';
import { Order } from 'types/entity/order';
import { useCart } from 'frontastic/hooks';

const INTERVAL_MS = 2500;
const MAX_RETRIES = 12;

const YggdrasilThankyouTastic = () => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const orderId = searchParams.get('orderId');

  const [order, setOrder] = useState<Order>();
  const [orderNumberPending, setOrderNumberPending] = useState(false);
  const { getOrder, resetCart, shippingMethods } = useCart();

  useEffect(() => {
    if (orderId) {
      resetCart?.();
      window.scrollTo({ top: 0 });
    }
  }, [orderId, resetCart]);

  useEffect(() => {
    setOrder(undefined);
    setOrderNumberPending(false);
    if (!orderId) return;

    let retries = 0;
    let timeout: ReturnType<typeof setTimeout> | null = null;

    const load = () => {
      getOrder(orderId).then((res) => {
        if (!res) {
          router.replace('/404');
          return;
        }
        setOrder(res);
        if (!res.orderNumber && retries < MAX_RETRIES) {
          retries += 1;
          setOrderNumberPending(true);
          timeout = setTimeout(load, INTERVAL_MS);
          return;
        }
        setOrderNumberPending(false);
      });
    };

    load();

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [getOrder, orderId, router]);

  return (
    <div data-testid={`order-${orderId}`}>
      {order ? (
        <ThankYouContent
          order={order}
          shippingMethods={shippingMethods.data ?? []}
          orderNumberPending={orderNumberPending}
        />
      ) : (
        <div className="flex h-[80vh] items-center justify-center">
          <div className="loading-full-screen" />
        </div>
      )}
    </div>
  );
};

export default YggdrasilThankyouTastic;
